
export const DOCX_MIME_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
export const DOC_MIME_TYPE = "application/msword";
export const PPTX_MIME_TYPE ="application/vnd.openxmlformats-officedocument.presentationml.presentation";
export const PPT_MIME_TYPE = "application/vnd.ms-powerpoint";
export const ODT_MIME_TYPE = "application/vnd.oasis.opendocument.text";
export const PNG_MIME_TYPE = "image/png";
export const JPEG_MIME_TYPE = "image/jpeg";
export const PDF_MIME_TYPE = "application/pdf";